export default __webpack_public_path__ + "static/media/img_two.d5f97349.png";